import { configureStore } from '@reduxjs/toolkit';
import photosReducer from '../slice/photosSlice';
import tagsReducer from '../slice/tagsSlice';
import filterReducer from '../slice/filterSlice';
import commentsReducer from '../slice/commentsSlice';
import ratingsReducer from '../slice/ratingsSlice';
import { createLogger } from '../utils/logger';

const logger = createLogger('Store');

// Load persisted filters from localStorage
const loadPersistedFilters = () => {
  try {
    const persistedFilters = localStorage.getItem('fm_filters');
    if (persistedFilters) {
      return JSON.parse(persistedFilters);
    }
  } catch (error) {
    logger.warn('Failed to load persisted filters:', error);
  }
  return undefined;
};

export const store = configureStore({
  reducer: {
    photos: photosReducer,
    tags: tagsReducer,
    filters: filterReducer,
    comments: commentsReducer,
    ratings: ratingsReducer,
  },
  preloadedState: {
    filters: loadPersistedFilters(),
  },
});

// Save filters to localStorage on every state change
store.subscribe(() => {
  try {
    const state = store.getState();
    localStorage.setItem('fm_filters', JSON.stringify(state.filters));
  } catch (error) {
    logger.warn('Failed to persist filters:', error);
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
